import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteTodo, toggleCompleted } from '../redux/actions';
import { statusFilters } from '../redux/constants';

function TodoList() {
  const tasks = useSelector((state) => state.tasks);
  const filter = useSelector((state) => state.filters.status);
  const dispatch = useDispatch();

  const visibleTasks = tasks.filter((todo) => {
    switch (filter) {
      case statusFilters.active:
        return !todo.completed;
      case statusFilters.completed:
        return todo.completed;
      default:
        return true;
    }
  });

  if (visibleTasks.length === 0) {
    return <p>No todos.</p>;
  }

  return (
    <ul>
      {visibleTasks.map((todo) => (
        <li key={todo.id}>
          <span
            onClick={() => dispatch(toggleCompleted(todo.id))}
         
          >
            {todo.text}
          </span>
          <button onClick={() => dispatch(deleteTodo(todo.id))}>Delete</button>
        </li>
      ))}
    </ul>
  );
}

export default TodoList;
